import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/corporateresponsibility.css';

const pillars = [
  {
    number: '01',
    title: 'Our Commitment to Sustainability',
    body: (
      <>
        <p>
          Sustainability is at the core of our corporate responsibility strategy. We are dedicated to
          minimizing our environmental footprint and promoting sustainable practices throughout our
          operations.
        </p>
        <ul>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Reducing Carbon Emissions</strong> — We
            strive to reduce our carbon emissions through energy-efficient practices, renewable energy
            sources, and responsible supply chain management.
          </li>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Waste Reduction</strong> — We are actively
            working to minimize waste generation and promote recycling and responsible disposal methods.
          </li>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Resource Conservation</strong> — We are
            committed to conserving natural resources and optimizing resource use in our products and
            services.
          </li>
        </ul>
      </>
    ),
  },
  {
    number: '02',
    title: 'Empowering Communities',
    body: (
      <>
        <p>
          We believe in giving back to the communities where we operate. Our community empowerment
          initiatives include:
        </p>
        <ul>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Education</strong> — We support
            educational programs and scholarships to empower future generations.
          </li>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Skills Development</strong> — We provide
            training and skill development opportunities to create a more skilled workforce.
          </li>
          <li>
            <strong style={{ color: 'rgba(240,242,245,0.8)' }}>Local Sourcing</strong> — We prioritize
            local sourcing and partnerships to support local businesses and economies.
          </li>
        </ul>
      </>
    ),
  },
  {
    number: '03',
    title: 'Ethical Business Practices',
    body: (
      <p>
        Integrity and ethical behavior are non-negotiable at Apex DeFi Labs. We uphold the highest
        standards of ethics in all our business dealings, ensuring transparency, fairness, and
        trustworthiness.
      </p>
    ),
  },
  {
    number: '04',
    title: 'Diversity and Inclusion',
    body: (
      <p>
        We value diversity and inclusivity within our workforce. Our commitment to diversity not only
        fosters a more creative and dynamic workplace but also reflects our dedication to equal
        opportunities for all.
      </p>
    ),
  },
  {
    number: '05',
    title: 'Health and Safety',
    body: (
      <p>
        The well-being of our employees and partners is of paramount importance. We maintain rigorous
        health and safety standards to provide a safe and secure working environment.
      </p>
    ),
  },
  {
    number: '06',
    title: 'Continuous Improvement',
    body: (
      <p>
        Corporate responsibility is not a one-time effort. We are committed to continually assessing our
        practices, seeking opportunities for improvement, and adapting to changing societal and
        environmental needs.
      </p>
    ),
  },
];

export default function CorporateResponsibilityPage() {
  return (
    <Layout>
      <SEO
        title="Corporate Responsibility - Apex DeFi Labs"
        description="Apex DeFi Labs is committed to making a positive impact through sustainability, community empowerment, ethical practices, and diversity."
        url="https://apexdefilabs.com/corporate-responsibility"
        type="website"
        keywords="Apex DeFi Labs corporate responsibility, sustainability, community, ethics, diversity"
      />

      <div className="cr-page">
        {/* Hero */}
        <section className="cr-hero">
          <div className="cr-hero-overlay" />
          <div className="cr-shell">
            <div style={{ marginBottom: '1.2rem' }}>
              <SectionLabel>Corporate Responsibility</SectionLabel>
            </div>
            <h1 className="cr-hero-title">
              Making a <em>Positive Impact</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="cr-content">
          <div className="cr-shell">
            {/* Intro */}
            <div className="cr-intro">
              <p>
                At Apex DeFi Labs, we believe that true success goes hand-in-hand with responsible business
                practices. We are committed to making a positive impact on society and the environment while
                achieving our business goals. Our corporate responsibility initiatives are an integral part
                of who we are and what we stand for.
              </p>
            </div>

            <div className="cr-pillars-grid">
              {pillars.map((pillar) => (
                <div key={pillar.number} className="cr-pillar-card">
                  <span className="cr-pillar-number">{pillar.number}</span>
                  <h3 className="cr-pillar-title">{pillar.title}</h3>
                  <div className="cr-pillar-body">{pillar.body}</div>
                </div>
              ))}
            </div>

            {/* Closing */}
            <div className="cr-closing">
              <h2 className="cr-closing-title">
                Join Us in <em>Making a Difference</em>
              </h2>
              <p className="cr-closing-body">
                We invite our employees, customers, partners, and stakeholders to join us in making a
                positive impact on the world. Together, we can create a more sustainable, equitable, and
                prosperous future.
              </p>
              <p className="cr-closing-body">
                At Apex DeFi Labs, corporate responsibility is not just a buzzword — it's a commitment we
                live by every day. We are proud of our efforts to contribute to a better world, and we will
                continue to push boundaries and set new standards in responsible business practices.
              </p>
              <p className="cr-closing-body">
                Thank you for being a part of our journey towards a brighter future.
              </p>
            </div>
          </div>
        </section>
      </div>
      {/* <BrandsSection brands={brands} isLoading={brandsLoading} /> */}
    </Layout>
  );
}
